// extracted by mini-css-extract-plugin
export default {"container":"b1-z"};